export default "__VITE_ASSET__XVzqfoEk__"